import { Navigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useUserNewsletter } from '../hooks/useUserNewsletter'

export default function RequiredNewsletterRoute({ children }) {
  const { newsletter } = useUserNewsletter()

  if (!isEmpty(newsletter) && newsletter.status !== 'active') {
    return <Navigate to="/newsletter/register" />
  }

  return children
}
